import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IWebsiteSidebar} from "../reducers/website-sidebar.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getWebsiteSidebarState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.websiteSidebar);


export const getWebsiteSidebarToggled = createSelector(getWebsiteSidebarState,
  (state: IWebsiteSidebar): boolean =>
    state.toggled
);
